import { render, staticRenderFns } from "./SearchGameList.vue?vue&type=template&id=f138c5e2&scoped=true"
import script from "./SearchGameList.vue?vue&type=script&lang=js"
export * from "./SearchGameList.vue?vue&type=script&lang=js"
import style0 from "./SearchGameList.vue?vue&type=style&index=0&id=f138c5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138c5e2",
  null
  
)

export default component.exports